import { getPortalId } from 'whisper-base';
const BASE_STORAGE_KEY = 'whisper_nudge_tracking_events';

/**
 * Gets the storage key for the current portal
 * @returns Storage key with portal ID or null if no portal ID is available
 */
function getStorageKey(portalId = getPortalId()) {
  return portalId ? `${BASE_STORAGE_KEY}_${portalId}` : null;
}

/**
 * Retrieves pending events from sessionStorage
 * @returns Array of stored NudgeEvents
 */
export function getPendingEvents(portalId = getPortalId()) {
  try {
    const storageKey = getStorageKey(portalId);
    const storedEvents = storageKey && sessionStorage.getItem(storageKey);
    return storedEvents ? JSON.parse(storedEvents) : [];
  } catch (_unused) {
    return [];
  }
}

/**
 * Stores events in sessionStorage that are pending to be sent
 * Merges with any existing events in storage
 * @param newEvents Array of NudgeEvents to store
 */
export function storePendingEvents(newEvents, portalId = getPortalId()) {
  try {
    if (newEvents.length === 0 || !portalId) {
      return;
    }
    const storageKey = getStorageKey(portalId);
    // Get existing events and merge with new ones
    const existingEvents = getPendingEvents(portalId);
    const allEvents = [...existingEvents, ...newEvents];
    sessionStorage.setItem(storageKey, JSON.stringify(allEvents));
  } catch (_unused2) {
    // Ignore error
  }
}

/**
 * Clears all stored pending events from sessionStorage
 */
export function clearPendingEvents(portalId = getPortalId()) {
  try {
    const storageKey = getStorageKey(portalId);
    if (storageKey) {
      sessionStorage.removeItem(storageKey);
    }
  } catch (_unused3) {
    // Ignore error
  }
}